import { gql } from '@apollo/client'

export const ACKNOWLEDGE_AI_INSIGHT = gql`
  mutation AcknowledgeAiInsight($insightId: ID!) {
    acknowledgeAiInsight(insightId: $insightId)
  }
`
